import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
  username: null,
  accessToken: null,
  refreshToken: null,
  authenticated: null,
  accessExpiresAt: null,
  refreshExpiresAt: null,
  userGroups: [],
  isSuperUser: null,
  firstname: '',
  lastname: '',
  stayLoggedIn: null,
  currentEvent: null,
  useDarkMode: false,
  lastActionAt: null,
  cashRegisterSession: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action) {
      return {
        ...state,
        id: action.payload.id,
        username: action.payload.username,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        authenticated: true,
        accessExpiresAt: action.payload.accessExpiresAt,
        refreshExpiresAt: action.payload.refreshExpiresAt,
        userGroups: action.payload.userGroups,
        isSuperUser: action.payload.isSuperUser,
        firstname: action.payload.firstname,
        lastname: action.payload.lastname,
        stayLoggedIn: action.payload.stayLoggedIn,
        lastActionAt: Date.now(),
      };
    },
    accessTokenSuccess(state, action) {
      state.authenticated = true;
      state.accessToken = action.payload.accessToken;
      state.accessExpiresAt = action.payload.accessExpiresAt;
      state.lastActionAt = Date.now();
    },
    updateLastAction(state) {
      state.lastActionAt = Date.now();
    },
    selectEvent(state, action) {
      state.currentEvent = action.payload;
    },
    setCashRegisterSession(state, action) {
      state.cashRegisterSession = action.payload;
    },
    toggleDarkMode(state) {
      state.useDarkMode = !state.useDarkMode;
    },
    logout(state) {
      return {
        ...initialState,
        authenticated: false,
      };
    },
  },
});

export const {
  loginSuccess,
  accessTokenSuccess,
  selectEvent,
  setCashRegisterSession,
  updateLastAction,
  logout,
  toggleDarkMode,
} = authSlice.actions;

export default authSlice.reducer;
